// @ts-nocheck
import FormInput from "components/Inputs/FormInput";
import { t } from "i18next";
import React, {useState} from "react";

export default function FormRangeOption({question}) {
	const default_max = 20;

	function getOption() {
		if (!question.options?.length)
			return (question.newOption({minValue: 1, maxValue: default_max}));
		let opt = question.options[0];
		// changeType() creates the option at 0/0: store the max shown below,
		// or the question is saved as 0/0 and cannot be answered
		if (!opt.maxValue) opt.maxValue = default_max;
		return (opt);
	}

	const [min, setMin] = useState(getOption().minValue);
	const [max, setMax] = useState(getOption().maxValue || default_max);

	function setMinValue(val) {
		let opt = getOption();
		opt.minValue = val;
		if (val >= max)
			setMax(val + 1);
		setMin(val);
	}

	function setMaxValue(val) {
		let opt = getOption();
		opt.maxValue = val;
		if (val <= min)
			setMin(val - 1);
		setMax(val);
	}

	return (
		<div className="option-cont d-flex w-100">
			<div className="d-flex flex-column w-100 me-2">
				<div>{t("Forms.RANGE_MIN")}</div>
				<div>
					<FormInput
						childClassName="bg-color-secondary"
						externvalue={"true"}
						onChange={(value) => setMinValue(Number(value))}
						value={min}
						max={max}
						type="number"
					/>
				</div>
			</div>
			<div className="d-flex flex-column w-100">
				<div>{t("Forms.RANGE_MAX")}</div>
				<div>
					<FormInput
						childClassName="bg-color-secondary"
						externvalue={"true"}
						onChange={(value) => setMaxValue(Number(value))}
						value={max}
						min={min}
						type="number"
					/>
				</div>
			</div>
		</div>
	);
}
